export const APP_AI_SECRET_PLACEHOLDER = '***';

export const APP_AI_PROVIDER_OPEN_AI = 0;
export const APP_AI_PROVIDER_DEEPSEEK = 2;

export const APP_AI_OPENAI_DEFAULT_MODEL = 'gpt-4o-mini';
export const APP_AI_DEEPSEEK_DEFAULT_MODEL = 'deepseek-chat';
